export default __webpack_public_path__ + "static/media/Marker4.6aec4ad8.svg";